import getSubscriptions from './getSubscriptions';

let subscriptions;

try {
  subscriptions = getSubscriptions() || {};
} catch (err) {
  subscriptions = {};
}

const exposeToChildFrames = () => {
  subscriptions = getSubscriptions(window);
};

const pubSub = Object.freeze({
  subscribe(name, fN) {
    if (!subscriptions[name]) {
      subscriptions[name] = {
        subscribers: [],
        record: undefined,
      };
    }

    if (subscriptions[name].subscribers.includes(fN)) {
      return;
    }

    subscriptions[name].subscribers.push(fN);

    return () =>
      subscriptions[name].subscribers.splice(
        subscriptions[name].subscribers.indexOf(fN),
        1
      );
  },
  publish(name, data) {
    if (!subscriptions[name]) {
      return;
      return console.warn(
        `%c ${`there are no subscribers to : '${name}' !!! `.toUpperCase()}`,
        'background: #ff0000; color: #bada55'
      );
    }

    subscriptions[name].record = {
      ...subscriptions[name].record,
      ...data,
    };

    for (const $ of subscriptions[name].subscribers) {
      $(subscriptions[name].record);
    }
  },
  query(name) {
    return subscriptions[name]
      ? { ...subscriptions[name].store }
      : console.warn(
          `%c ${`there is no store to query on : '${name}' !!! `.toUpperCase()}`,
          'background: #ff0000; color: #bada55'
        );
  },
});

export default pubSub;
export { exposeToChildFrames };
